export default "<app-clients-list></app-clients-list>";